/* eslint-disable no-undef,react/prop-types */
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getClientNotices } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';

class Notifications extends PureComponent {
  componentWillUpdate(nextProps) {
    if (nextProps.clientNotices.length !== this.props.clientNotices.length) {
      let message = '';
      if (nextProps.clientNotices[0].title) {
        message = `<h4>${nextProps.clientNotices[0].title}</h4><p>${nextProps.clientNotices[0].message}</p>`;
      } else {
        message = `<p>${nextProps.clientNotices[0].message}</p>`;
      }

      $.notify(message, nextProps.clientNotices[0].type);
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  clientNotices: getClientNotices(state)
});

export default connect(mapStateToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js